import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import bugsnag from 'bugsnag-js';
import { environment } from 'environments/environment';

@Injectable()
export class CorsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const bugSnagClient = bugsnag({
          appVersion: environment.appVersion,
          apiKey: '4c04ddb8868eaad868b9d86299898e2d',
          releaseStage: environment.production ? 'production' : 'development'
        });
        if (error.error instanceof ProgressEvent && error.status === 0) {
          bugSnagClient.notify('CORS error detected or network issue', {
            severity: 'error',
            metaData: error,
            request: req,
            ...(localStorage.getItem('userData') && { user: JSON.parse(localStorage.getItem('userData')) })
          });
          console.error('CORS error detected or network issue');
        }
        return throwError(error);
      })
    );
  }
}
